import React from 'react';

const TeamCard = ({ team }) => {
  if (!team) {
    return null;
  }

  const getColorFromName = (nombre = '') => {
    let hash = 0;
    let hasNumbers = false;
    let numberSum = 0;
    
    for (let i = 0; i < nombre.length; i++) {
      const char = nombre[i];
      const code = nombre.charCodeAt(i);
      
      if (char >= '0' && char <= '9') {
        hasNumbers = true;
        const numValue = parseInt(char, 10);
        numberSum += numValue * 3;
        hash += numValue * 37;
      }
      
      hash = code + ((hash << 5) - hash);
    }
    
    if (hasNumbers) {
      hash += numberSum * 17;
    }
    
    const h = Math.abs(hash) % 360;
    const s = hasNumbers 
      ? 65 + (Math.abs(hash) % 20)
      : 60 + (Math.abs(hash) % 20);
    const l = hasNumbers
      ? 40 + (Math.abs(hash >> 2) % 20)
      : 45 + (Math.abs(hash) % 10);

    return `hsl(${h}, ${s}%, ${l}%)`;
  };

  // Destructuración con nuevos campos
  const {
    nombre = 'Sin nombre',
    operaciones = 0,
    importe = 0,
    pvp = 0,
    porcentajeImporte = 0,
    porcentajePvp = 0
  } = team;

  const avatarColor = getColorFromName(nombre);

  // Formatear moneda
  const formatCurrency = (value) => {
    return Number(value).toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  // Formatear número
  const formatNumber = (value) => {
    return Number(value).toLocaleString('de-DE', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  };

  // Formatear porcentaje
  const formatPercent = (value) => {
    const num = Number(value);
    const sign = num >= 0 ? '+' : '';
    return `${sign}${num.toFixed(1)}%`;
  };

  return (
    <div className="team-card">
      <div className="team-info">
        <div
          className="team-avatar"
          style={{ background: avatarColor }}
        >
          {nombre !== "SERVIDOR" ? nombre.slice(-1) : nombre.charAt(0)}
        </div>
        
        <div className="team-details">
          <h3>{nombre}</h3>
          <span className="team-ops">
            {formatNumber(operaciones)} operaciones
          </span>
        </div>
      </div>

      {/* Métricas financieras */}
      <div className="team-metrics">
        
        <div className="team-metric">
          <span className="metric-label">PVP</span>
          <span className="metric-value">{formatCurrency(pvp)} €</span>
          <span className={`metric-percent ${porcentajePvp >= 0 ? 'positive' : 'negative'}`}>
            {formatPercent(porcentajePvp)}
          </span>
        </div>

        <div className="team-metric-divider"></div>

        <div className="team-metric">
          <span className="metric-label">Importe</span>
          <span className="metric-value">{formatCurrency(importe)} €</span>
          <span className={`metric-percent ${porcentajeImporte >= 0 ? 'positive' : 'negative'}`}>
            {formatPercent(porcentajeImporte)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default TeamCard;